import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NextStepHint } from './next-step';

/**
 * Channel between the configurator's NavbarComponent (owns tabs, locking and
 * selection) and the choices rail on the product page.
 */
@Injectable({ providedIn: 'root' })
export class ConfiguratorProgressService {
  private readonly _hint = new BehaviorSubject<NextStepHint | null>(null);
  readonly hint$: Observable<NextStepHint | null> = this._hint.asObservable();

  private readonly _checkoutRequests = new Subject<void>();
  /** NEXT on the last tab asks the rail to start checkout. */
  readonly checkoutRequests$: Observable<void> = this._checkoutRequests.asObservable();

  private readonly _nextTabRequests = new Subject<void>();
  /** The rail's "Continue" asks the navbar to move to the next tab. */
  readonly nextTabRequests$: Observable<void> = this._nextTabRequests.asObservable();

  setHint(hint: NextStepHint | null): void {
    // Published after every tab-activation pass; skip identical values.
    if (JSON.stringify(hint) !== JSON.stringify(this._hint.value)) {
      this._hint.next(hint);
    }
  }

  requestCheckout(): void {
    this._checkoutRequests.next();
  }

  requestNextTab(): void {
    this._nextTabRequests.next();
  }
}
